import { Initialize, ISortOrder, Condition, FileType, } from "@warda/library-ui/interfaces";
import { SegmentedViewType } from "@warda/library-ui/core/SegmentedView";
import { isMobile } from "@warda/library-ui/utils/deviceUtils";
import updateFilesSlcId from "../AreaMediaLibrary/AreaFiles/utils/updateFilesSlcId";
import { wsItemError, wsItemFinish, wsItemUpdate } from "../websocketUpdates";
import { ViewMode, FileTypeId, FileTypeText } from "./constants";
import { areFiltersUseful, clearFiltersAttr, } from "../PanelFilters";
import onlyDistinctFiles from "../AreaMediaLibrary/AreaFiles/utils/onlyDistinctFiles";
const getPageHrchId = ({ pageHrchId, files }) => {
    if (!!pageHrchId)
        return pageHrchId;
    if (files.length === 1)
        return files[0].data.hierarchyId;
    return undefined;
};
const getPagePrntId = ({ pagePrntId, files }) => {
    if (!!pagePrntId)
        return pagePrntId;
    if (files.length === 1)
        return files[0].id;
    return undefined;
};
export var ACT_VPORT;
(function (ACT_VPORT) {
    ACT_VPORT["INIT_SEARCH_STARTED"] = "INIT_SEARCH_STARTED";
    ACT_VPORT["INIT_SEARCH_LOADING"] = "INIT_SEARCH_LOADING";
    ACT_VPORT["INIT_SEARCH_RESULT"] = "INIT_SEARCH_RESULT";
    ACT_VPORT["INIT_MORE_STARTED"] = "INIT_MORE_STARTED";
    ACT_VPORT["INIT_MORE_LOADING"] = "INIT_MORE_LOADING";
    ACT_VPORT["INIT_MORE_RESULT"] = "INIT_MORE_RESULT";
    ACT_VPORT["LOADED_MORE_FILES"] = "LOADED_MORE_FILES";
    ACT_VPORT["DOWNLOADS_TO_ADD"] = "DOWNLOADS_TO_ADD";
    ACT_VPORT["DOWNLOADS_ERROR"] = "DOWNLOADS_ERROR";
    ACT_VPORT["DOWNLOADS_UPDATE"] = "DOWNLOADS_UPDATE";
    ACT_VPORT["DOWNLOADS_FINISH"] = "DOWNLOADS_FINISH";
    ACT_VPORT["DOWNLOADS_REMOVE"] = "DOWNLOADS_REMOVE";
    ACT_VPORT["SELECT_FILE_CLICK"] = "SELECT_FILE_CLICK";
    ACT_VPORT["SELECT_FILE_CHECK"] = "SELECT_FILE_CHECK";
    ACT_VPORT["DESELECT_FILES"] = "DESELECT_FILES";
    ACT_VPORT["SORT"] = "SORT";
    ACT_VPORT["NAVIGATION"] = "NAVIGATION";
    ACT_VPORT["BREADCRUMB"] = "BREADCRUMB";
    ACT_VPORT["DIALOG_DOWNLOAD"] = "DIALOG_DOWNLOAD";
    ACT_VPORT["DIALOG_DETAIL"] = "DIALOG_DETAIL";
    ACT_VPORT["DIALOG_VIEWER"] = "DIALOG_VIEWER";
    ACT_VPORT["FILTER"] = "FILTER";
    ACT_VPORT["VIEW_TYPE"] = "VIEW_TYPE";
    ACT_VPORT["VIEW_MODE_SEARCH"] = "VIEW_MODE_SEARCH";
    ACT_VPORT["VIEW_MODE_NAVIGA"] = "VIEW_MODE_NAVIGA";
    ACT_VPORT["SET_LOGO_READY"] = "SET_LOGO_READY";
})(ACT_VPORT || (ACT_VPORT = {}));
export const reducerInitState = {
    logoReady: false,
    pageHrchId: undefined,
    pagePrntId: undefined,
    initSearch: Initialize.START,
    initMore: Initialize.NONE,
    moreType: undefined,
    initMsgErr: undefined,
    folderPath: [],
    files: [],
    filesTotal: {
        [FileType.FOLDER]: 0,
        [FileType.MEDIA]: 0,
        [FileType.PORTAL]: 0,
    },
    filesSlcId: [],
    filters: [
        {
            id: "name",
            type: "FACETTEXTAREA",
        },
        {
            id: "fileType",
            type: "SIMPLE_SELECTION",
            options: [
                FileTypeId.FOLDER,
                FileTypeId.DOCUMENT,
                FileTypeId.IMAGE,
                FileTypeId.VIDEO,
                FileTypeId.OTHER,
            ].map((id) => ({ id, label: FileTypeText[id] })),
        },
    ],
    filtersCondition: Condition.AND,
    sortKey: "name",
    sortOrd: ISortOrder.ASC,
    viewMode: ViewMode.NAVIGATION,
    viewType: SegmentedViewType.LIST,
    downloads: [],
    dialogDownload: false,
    dialogDetail: false,
    dialogViewer: false,
};
const reducer = (state, action) => {
    var _a;
    const newState = { ...state };
    switch (action.type) {
        case ACT_VPORT.SET_LOGO_READY:
            newState.logoReady = true;
            return newState;
        case ACT_VPORT.INIT_SEARCH_STARTED:
            newState.initSearch = Initialize.START;
            newState.initMsgErr = reducerInitState.initMsgErr;
            newState.filters = reducerInitState.filters;
            return newState;
        case ACT_VPORT.INIT_SEARCH_LOADING:
            newState.initSearch = Initialize.WAIT;
            newState.initMsgErr = reducerInitState.initMsgErr;
            newState.filesSlcId = reducerInitState.filesSlcId;
            return newState;
        case ACT_VPORT.INIT_SEARCH_RESULT: {
            const result = action.result;
            newState.initSearch = result.initSearch;
            newState.initMsgErr = result.error;
            newState.folderPath = (_a = result.folderPath) !== null && _a !== void 0 ? _a : [];
            newState.files = result.files;
            newState.filesTotal = result.filesTotal;
            newState.pageHrchId = getPageHrchId(newState);
            newState.pagePrntId = getPagePrntId(newState);
            return newState;
        }
        case ACT_VPORT.LOADED_MORE_FILES:
            newState.files = newState.files.concat(action.files);
            return newState;
        case ACT_VPORT.DOWNLOADS_TO_ADD: {
            const { correlationId, filename } = action.payload;
            const newDownloads = Array.from(newState.downloads);
            newDownloads.push({
                id: correlationId,
                loading: true,
                name: filename,
                url: "",
            });
            newState.downloads = newDownloads;
            return newState;
        }
        case ACT_VPORT.DOWNLOADS_ERROR: {
            const newDownloads = wsItemError(newState.downloads, action.payload);
            // nothing to update - return state to avoid rerender
            if (!newDownloads.length)
                return state;
            newState.downloads = newDownloads;
            return newState;
        }
        case ACT_VPORT.DOWNLOADS_UPDATE: {
            const newDownloads = wsItemUpdate(newState.downloads, action.payload);
            // nothing to update - return state to avoid rerender
            if (!newDownloads.length)
                return state;
            newState.downloads = newDownloads;
            return newState;
        }
        case ACT_VPORT.DOWNLOADS_FINISH: {
            const newDownloads = wsItemFinish(newState.downloads, action.payload);
            // nothing to update - return state to avoid rerender
            if (!newDownloads.length)
                return state;
            newState.downloads = newDownloads;
            return newState;
        }
        case ACT_VPORT.DOWNLOADS_REMOVE: {
            const newDownloads = Array.from(newState.downloads);
            const file = action.file;
            const { id, url } = file;
            const index = newDownloads.findIndex((i) => i.id === id);
            if (index !== -1) {
                const anchor = document.createElement("a");
                document.body.appendChild(anchor);
                anchor.href = url;
                anchor.click();
                document.body.removeChild(anchor);
                newDownloads.splice(index, 1);
            }
            newState.downloads = newDownloads;
            return newState;
        }
        case ACT_VPORT.SELECT_FILE_CLICK: {
            const { files, filesSlcId } = newState;
            const { id, keyDownCtrl, keyDownMeta, detail } = action;
            newState.filesSlcId = updateFilesSlcId({
                files,
                filesSlcId,
                id,
                keyDownCtrl,
                keyDownMeta,
            });
            if (detail === true) {
                newState.dialogDetail = true;
            }
            return newState;
        }
        case ACT_VPORT.SELECT_FILE_CHECK: {
            const { files, filesSlcId } = newState;
            const { id, keyDownCtrl, keyDownMeta } = action;
            newState.filesSlcId = updateFilesSlcId({
                files,
                filesSlcId,
                id,
                keyDownCtrl,
                keyDownMeta,
            });
            return newState;
        }
        case ACT_VPORT.DESELECT_FILES:
            newState.filesSlcId = reducerInitState.filesSlcId;
            return newState;
        case ACT_VPORT.SORT:
            newState.sortKey = action.key || newState.sortKey;
            newState.sortOrd = action.ord || newState.sortOrd;
            newState.initSearch = Initialize.START;
            return newState;
        case ACT_VPORT.VIEW_TYPE:
            newState.viewType = action.view;
            return newState;
        case ACT_VPORT.NAVIGATION: {
            const { id, name } = action;
            const newPath = Array.from(newState.folderPath);
            if (!!name) {
                newPath.push({ id, name });
            }
            else {
                newPath.pop();
            }
            newState.files = reducerInitState.files;
            newState.filesTotal = reducerInitState.filesTotal;
            newState.filesSlcId = reducerInitState.filesSlcId;
            newState.filters = reducerInitState.filters;
            newState.initSearch = Initialize.START;
            newState.folderPath = newPath;
            return newState;
        }
        case ACT_VPORT.BREADCRUMB: {
            const pathId = action.pathId;
            const newPath = Array.from(newState.folderPath);
            // aggiungo nel newPath un oggetto temporaneo
            // newPath verrà sistemato nell'inizializzazione
            newPath.push({ id: pathId, name: "..." });
            newState.files = reducerInitState.files;
            newState.filesTotal = reducerInitState.filesTotal;
            newState.filesSlcId = reducerInitState.filesSlcId;
            newState.filters = reducerInitState.filters;
            newState.initSearch = Initialize.START;
            newState.folderPath = newPath;
            return newState;
        }
        case ACT_VPORT.DIALOG_DOWNLOAD: {
            const { open, fileId } = action;
            if (open !== undefined) {
                newState.dialogDownload = action.open;
            }
            else {
                newState.dialogDownload = !newState.dialogDownload;
            }
            if (fileId !== undefined) {
                newState.filesSlcId = [fileId];
            }
            return newState;
        }
        case ACT_VPORT.DIALOG_DETAIL:
            newState.dialogDetail = !newState.dialogDetail;
            newState.dialogViewer = reducerInitState.dialogViewer;
            if (isMobile()) {
                newState.filesSlcId = reducerInitState.filesSlcId;
            }
            return newState;
        case ACT_VPORT.DIALOG_VIEWER:
            newState.dialogViewer = !newState.dialogViewer;
            return newState;
        case ACT_VPORT.FILTER: {
            const clearAll = action.clearAll;
            const index = action.index;
            const value = action.value;
            if (clearAll) {
                newState.filters = clearFiltersAttr(newState.filters);
            }
            else {
                newState.filters = newState.filters.map((f, i) => {
                    if (index !== i)
                        return f;
                    return { ...f, value: value };
                });
            }
            newState.viewMode = ViewMode.SEARCH;
            newState.files = reducerInitState.files;
            newState.filesTotal = reducerInitState.filesTotal;
            newState.filesSlcId = reducerInitState.filesSlcId;
            newState.folderPath = reducerInitState.folderPath;
            if (areFiltersUseful(newState.filters) || !isMobile()) {
                newState.initSearch = Initialize.START;
            }
            return newState;
        }
        case ACT_VPORT.VIEW_MODE_SEARCH:
            newState.viewMode = ViewMode.SEARCH;
            newState.files = reducerInitState.files;
            newState.filesTotal = reducerInitState.filesTotal;
            newState.filesSlcId = reducerInitState.filesSlcId;
            return newState;
        case ACT_VPORT.VIEW_MODE_NAVIGA:
            newState.viewMode = ViewMode.NAVIGATION;
            newState.filters = reducerInitState.filters;
            newState.files = reducerInitState.files;
            newState.filesTotal = reducerInitState.filesTotal;
            newState.filesSlcId = reducerInitState.filesSlcId;
            newState.initSearch = Initialize.START;
            return newState;
        case ACT_VPORT.INIT_MORE_STARTED:
            newState.initMore = Initialize.START;
            newState.moreType = action.moreType;
            return newState;
        case ACT_VPORT.INIT_MORE_LOADING:
            newState.initMore = Initialize.WAIT;
            return newState;
        case ACT_VPORT.INIT_MORE_RESULT:
            const preAddLength = newState.files.length;
            newState.files = onlyDistinctFiles(newState.files, action.files);
            if (preAddLength === newState.files.length ||
                (action.files.length === 0 &&
                    action.filesTotal[newState.moreType] >
                        newState.files.filter((f) => f.type === newState.moreType).length)) {
                newState.initMore = Initialize.FAIL;
            }
            else {
                newState.initMore = reducerInitState.initMore;
            }
            newState.filesTotal = action.filesTotal;
            newState.moreType = reducerInitState.moreType;
            return newState;
        default:
            console.error(`no action ${action.type}`);
            return state;
    }
};
export default reducer;
